import { render, staticRenderFns } from "./VideoAnswer.vue?vue&type=template&id=53722d09&scoped=true&"
import script from "./VideoAnswer.vue?vue&type=script&lang=js&"
export * from "./VideoAnswer.vue?vue&type=script&lang=js&"
import style0 from "./VideoAnswer.vue?vue&type=style&index=0&id=53722d09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53722d09",
  null
  
)

export default component.exports